export const path = {
    HOME: '/*',
    LOGIN: 'login',
    CHO_THUE_CAN_HO: 'cho-thue-can-ho',
    CHO_THUE_MAT_BANG: 'cho-thue-mat-bang',
    NHA_CHO_THUE: 'nha-cho-thue',
    CHO_THUE_PHONG_TRO: 'cho-thue-phong-tro',
    SEARCH: 'tim-kiem',
    DETAIL_POST__TITLE__POSTID: 'chi-tiet/:title/:postId',
    DETAIL: 'chi-tiet/',
    DETAIL_ALL: 'chi-tiet/*',

    SYSTEM: '/he-thong/*',
    CREATE_POST: 'tao-moi-bai-dang',
    MANAGE_POST: 'quan-ly-bai-dang',
    EDIT_PROFILE: 'sua-thong-tin-ca-nhan',
    CONTACTS: 'lien-he',
}

export const formatSlug = (keyword) => {
    return keyword
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, "")
        .split(" ")
        .join("-")
}

export const text = {
    HOME_TITLE: 'Tìm kiếm chỗ thuê ưng ý',
    HOME_DESCRIPTION: 'Kênh thông tin Phòng trọ số 1 Việt Nam - Website đăng tin cho thuê phòng trọ, nhà nguyên căn, căn hộ, ở ghép nhanh, hiệu quả với 100.000+ tin đăng và 2.500.000 lượt xem mỗi tháng.',
}

export const location = [
    {
        id: 'hcm',
        name: 'Phòng trọ Hồ Chí Minh',
        image: 'https://phongtro123.com/images/location_hcm.jpg',
        provinceCode: 'CHMN'
    },
    {
        id: 'hn',
        name: 'Phòng trọ Hà Nội',
        image: 'https://phongtro123.com/images/location_hn.jpg',
        provinceCode: 'NNIT'
    },
    {
        id: 'dn',
        name: 'Phòng trọ Đà Nẵng',
        image: 'https://phongtro123.com/images/location_dn.jpg',
        provinceCode: 'NONG'
    },
]